import React, { useState, useEffect } from "react";
import axios from "axios";
import { useGlobalContext } from "../../../Context/Context";
import "./docs.css";
import eyeImg from "../../picture/Visible.png";

function Docs({ selectedDocumentUrl, setSelectedDocument }) {
  const [mainCategories, setMainCategories] = useState([]);
  const [activeMainCategory, setActiveMainCategory] = useState(null);
  const [subCategories, setSubCategories] = useState([]);
  const [expandedSubCategories, setExpandedSubCategories] = useState([]);
  const [documents, setDocuments] = useState({});
  const { setSelectedDocumentUrl } = useGlobalContext(); // New state for managing the document URL
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchMainCategories();
  }, []);

  const fetchMainCategories = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://data.nadzor.app/api/admin_panel/our_docs/read.php",
        { type: "main_categories" }
      );
      if (response.data.status === 200) {
        setMainCategories(response.data.categories);
      } else {
        console.error("Failed to fetch main categories.");
      }
    } catch (error) {
      console.error("Error fetching main categories:", error);
    } finally {
      setLoading(false);
    }
  };



  const fetchSubCategories = async (mdcId) => {
    if (activeMainCategory === mdcId) {
      setActiveMainCategory(null);
      setSubCategories([]);
      setExpandedSubCategories([]);
      setDocuments({});
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "https://data.nadzor.app/api/admin_panel/our_docs/read.php",
        { type: "sub_categories", mdc_id: mdcId }
      );
      if (response.data.status === 200) {
        setActiveMainCategory(mdcId);
        setSubCategories(response.data.sub_categories);
        setExpandedSubCategories([]);
        setDocuments({});
      } else {
        console.error("Failed to fetch subcategories.");
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDocuments = async (sdcId) => {
    if (expandedSubCategories.includes(sdcId)) {
      setExpandedSubCategories(
        expandedSubCategories.filter((id) => id !== sdcId)
      );
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "https://data.nadzor.app/api/admin_panel/our_docs/read.php",
        { type: "documents", sdc_id: sdcId }
      );
      if (response.data.status === 200) {
        setExpandedSubCategories([...expandedSubCategories, sdcId]);
        setDocuments((prevDocs) => ({
          ...prevDocs,
          [sdcId]: response.data.documents,
        }));
      } else {
        console.error("Failed to fetch documents.");
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleViewDocument = (doc) => {
    // Find all documents with the same name
    const matchingDocuments = Object.values(documents)
      .flat() // Flatten the array of documents
      .filter((d) => d.title === doc.title); // Find all documents with the same title

    setSelectedDocument(matchingDocuments); // Store all matching documents
  };


  return (
    <div className="docs-wrapper">
      {mainCategories.map((category) => (
        <div key={category.id}>
          {/* Main Category */}
          <div
            className="docs-main-category"
            onClick={() => fetchSubCategories(category.id)}
          >
            {category.title}
          </div>

          {/* Subcategories */}
          {activeMainCategory === category.id && (
            <div className="docs-subcategories">
              {subCategories.map((subCategory) => (
                <div key={subCategory.id} className="docs-subcategory">
                  <div className="subcategory-header">
                    <span
                      className="toggle-icon"
                      onClick={() => fetchDocuments(subCategory.id)}
                    >
                      {expandedSubCategories.includes(subCategory.id) ? "-" : "+"}
                    </span>
                    {subCategory.title}
                  </div>

                  {/* Documents */}
                  {expandedSubCategories.includes(subCategory.id) && (
                    <div className="docs-documents">
                      {(documents[subCategory.id] || []).map((doc, index, arr) => (
                        <div key={doc.id}>
                          <div className="docs-document">
                            <span
                              title={doc.title}
                              onClick={() => handleViewDocument(doc)}
                              style={{ cursor: "pointer"}} // Style like a link
                            >
                              {doc.title.length > 20 ? `${doc.title.substring(0, 20)}...` : doc.title}
                            </span>


                            <a href={doc.pdf_url} target="_blank" rel="noreferrer">
                              <img src={eyeImg} alt="view" />
                            </a>
                          </div>
                          {index < arr.length - 1 && <hr />} {/* Add <hr> between documents */}
                        </div>
                      ))}

                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default Docs;
